import React from "react";

const TotalStatus = (props) => {
    return (
        <div className="ag-status-name-value">
      <span className="component">Total : </span>
      <span className="ag-status-name-value-value">0</span>
    </div>
    )
}
export default TotalStatus